import { AppState } from 'models/app-store';
import { useSelector } from 'react-redux';
import { OperationTypes } from 'utils/enums/system-template';

const useOperationType = (): OperationType => {
  const operationType = useSelector((state: AppState) => state.auth.session?.view.operation) || OperationTypes.Default;
  const isSchoolOperationsEnabled = !!useSelector((app: AppState) => app.auth.session?.view.isSchoolOperationsEnabled);
  const isEmployeeOperationsEnabled = !!useSelector((app: AppState) => app.auth.session?.view.isEmployeeOperationsEnabled);

  return { operationType, isSchoolOperationsEnabled, isEmployeeOperationsEnabled };
};

export default useOperationType;

export type OperationType = {
  operationType: OperationTypes;
  isSchoolOperationsEnabled: boolean;
  isEmployeeOperationsEnabled: boolean;
};
